module.exports = __webpack_public_path__ + "static/media/step2img10.e80ce245.JPG";